import { render, staticRenderFns } from "./kfjk.vue?vue&type=template&id=1d48bbba&scoped=true"
import script from "./kfjk.vue?vue&type=script&lang=js"
export * from "./kfjk.vue?vue&type=script&lang=js"
import style0 from "./kfjk.vue?vue&type=style&index=0&id=1d48bbba&lang=scss&scoped=true"
import style1 from "./kfjk.vue?vue&type=style&index=1&id=1d48bbba&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48bbba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d48bbba')) {
      api.createRecord('1d48bbba', component.options)
    } else {
      api.reload('1d48bbba', component.options)
    }
    module.hot.accept("./kfjk.vue?vue&type=template&id=1d48bbba&scoped=true", function () {
      api.rerender('1d48bbba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/messagejk/kfjk.vue"
export default component.exports